import { render } from "./ResourceCancelModal.vue?vue&type=template&id=d5366364&scoped=true"
import script from "./ResourceCancelModal.vue?vue&type=script&lang=js"
export * from "./ResourceCancelModal.vue?vue&type=script&lang=js"

import "./ResourceCancelModal.vue?vue&type=style&index=0&id=d5366364&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5366364"]])

export default __exports__